import React from "react";

const AvisoLegalPage = () => {
    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow mt-6 mb-12">
            <h1 className="text-3xl font-bold text-brand-blue mb-4">Aviso Legal</h1>
            <p className="text-gray-700">
                Esta web es un proyecto en desarrollo. Los datos mostrados son estimaciones
                y no constituyen asesoramiento legal ni financiero. Reformista.net no se hace responsable
                de decisiones tomadas en base a los datos aquí publicados.
            </p>
            <p className="mt-4 text-gray-500 text-sm">
                © {new Date().getFullYear()} reformista.net. Todos los derechos reservados.
            </p>
        </div>
    );
};

export default AvisoLegalPage;
